import GroupPhoto from './GroupPhoto';
export default GroupPhoto;

